
import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { RouterModule } from "@angular/router";
import { AuthGuard } from "../auth-guard.service";
import { AccountGuard } from "../account-guard.service";
import { BlogsComponent } from "./blogs.component";
import { BlogService } from "./blog.service";
 
@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild([
            { path: 'blogs', component: BlogsComponent}
        ])
    ],
    exports: [

    ],
    declarations: [
        BlogsComponent,
        
    ],
    providers: [
        BlogService
    ]
})
export class BlogsModule {

}



// WEBPACK FOOTER //
// ./src/app/blogs/blogs.module.ts